import { Component } from "react";
import { Flex, Spinner } from "@xometry/xometry_loft";

enum ModelState {
  LOADING = "loading",
  LOADED = "loaded",
}

interface State {
  modelState: ModelState;
}

class Loader extends Component<Record<string, unknown>, State> {
  constructor(props) {
    super(props);
    this.state = {
      modelState: ModelState.LOADING,
    };
  }

  reset = () => {
    this.setState({ modelState: ModelState.LOADING });
  };

  modelLoaded = () => {
    this.setState({ modelState: ModelState.LOADED });
  };

  render() {
    const { modelState } = this.state;

    if (modelState === ModelState.LOADED) {
      return null;
    }

    return (
      <Flex height="100%" alignItems="center">
        <Spinner scale="full-screen" />
      </Flex>
    );
  }
}

export default Loader;
